import { Chart, ChartOption } from '@/components/Base/Chart.tsx';
import { formatLargeNumber } from '@/utils/formatLargNumber';
import { Box } from '@mui/material';
import { graphic } from 'echarts';
import { useEffect, useState } from 'react';

const ScoreInadimplenciaChartBarLine = ({ color, title, labelColor, data }) => {
  const [drawerWidth, setDrawerWidth] = useState(
    window.innerWidth < 1540 ? 'Percent. de Inad.' : 'Percentual de Inadimplência'
  );

  useEffect(() => {
    const handleResize = () => {
      setDrawerWidth(
        window.innerWidth < 1540 ? 'Percent. de Inad.' : 'Percentual de Inadimplência'
      );
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const months = data?.valor_score_meses?.map(
    (item) => item.nome.charAt(0).toUpperCase() + item.nome.slice(1)
  );
  const receivedValues = data?.valor_score_meses?.map((item) => item.valor);
  const delinquentPercentages = data?.valor_score_meses?.map((item) => item.valor_secundario);

  const series = [
    {
      data: receivedValues,
      type: 'bar',
      stack: 'a',
      name: 'Valor inadimplente',
      itemStyle: {
        borderRadius: [8, 8, 8, 8],
        color: color,
      },
      label: {
        show: true,
        formatter: (params) => formatLargeNumber(Number(params.value)),
        color: '#000',
        align: 'center',
        fontSize: '14px',
        fontWeight: 'bold',
        distance: 5,
      },
    },
    {
      name: drawerWidth,
      type: 'line',
      smooth: true,
      yAxisIndex: 1,
      data: delinquentPercentages,
      color: '#000',
      lineStyle: {
        color: 'black',
        width: 4,
      },
      label: {
        show: true,
        formatter: (params) =>
          `${formatLargeNumber(delinquentPercentages[params.dataIndex]?.toFixed(0))}%`,
        position: 'top',
        backgroundColor: labelColor,
        padding: [8, 5],
        borderRadius: 50,
        fontSize: '11px',
        color: '#fff',
        align: 'center',
        fontWeight: 'bold',
        distance: -15,
      },
    },
  ];

  const option = {
    title: {
      text: title,
      textStyle: {
        fontSize: '12px',
      },
    },

    grid: {
      left: '3%',
      right: '7%',
      bottom: '3%',
      containLabel: true,
    },

    legend: {
      data: [
        { name: drawerWidth, icon: 'circle'}, 
        { name: 'Valor inadimplente', icon: 'circle'},
      ],
      right: '0',
    },
    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        let tooltipContent = '';
        params.forEach((param) => {
          if (param.seriesType === 'bar') {
            tooltipContent += `
              <div> Mês: ${param.name} </div>
              <div> Valor inadimplente: ${formatLargeNumber(param.value)} </div>
            `;
          } else if (param.seriesType === 'line') {
            tooltipContent += `
              <div> Percentual de Inadimplência: ${param.value.toFixed(2)}% </div>
            `;
          }
        });
        return tooltipContent;
      },
    },
    yAxis: [
      {
        type: 'value',
        name: 'Valor inadimplente',
        position: 'left',
      },
      {
        type: 'value',
        name: 'Percentual de Inadimplência',
        position: 'right',
        axisLabel: {
          formatter: '{value}%',
        },
      },
    ],
    xAxis: {
      type: 'category',
      data: months,
    },
    series,
  } as ChartOption;

  return (
    <Box
      sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', padding: '20px 10px 0 10px' }}
      height={'400px'}
    >
      <Chart option={option} />
    </Box>
  );
};

export default ScoreInadimplenciaChartBarLine;
